import React from 'react';

import cn from 'classnames';
import PropTypes from 'prop-types';
import { IoSearch } from 'react-icons/io5';

import ViewImage from 'modules/common/Img/components/ViewImage';

function Variants({ form, setForm, variantExists, data }) {
  const handleOnChange = (row, remaining) => () => {
    if (remaining <= 0) return;

    setForm((prevState) => ({
      ...prevState,
      selected_variant: row,
    }));
  };

  return (
    <div className="space-y-3">
      <div>
        <div className="font-semibold">Variants</div>
        <div className="text-sm text-gray-500">
          Choose a variant of this product below
        </div>
      </div>

      <div className="grid grid-cols-2 gap-2">
        {form?.variants?.length > 0 ? (
          form?.variants?.map((item, key) => {
            const isExisting =
              false ??
              (variantExists(item)?.length > 0 &&
                data?.selected_variant?.uuid !== item?.uuid);

            let remaining = item?.remaining;

            if (data?.type === 'Fixed') remaining = 1;

            return (
              <div
                className="relative has-tooltip"
                // eslint-disable-next-line react/no-array-index-key
                key={key}
              >
                <div
                  className={cn(
                    'flex border text-black rounded cursor-pointer min-h-[64px]',
                    {
                      'border-primary-500 !text-primary-500 bg-primary-50':
                        form?.selected_variant?.uuid === item?.uuid,
                      '!opacity-40 !cursor-not-allowed':
                        isExisting || remaining <= 0,
                    }
                  )}
                  onClick={handleOnChange(item, remaining)}
                  role="presentation"
                >
                  <div className="w-16 border-r">
                    <ViewImage
                      src={item?.photo_url}
                      className="w-16 object-cover rounded-l-sm"
                      heightClassName="h-full"
                      containerClassName="h-full"
                      hoverLabel={<IoSearch className="h-5 w-5" />}
                      stopPropagation
                    />
                  </div>
                  <div className="flex flex-col p-2 px-3 space-y-0.5 flex-1">
                    <div className="font-semibold capitalize text-xs">
                      {item?.name}
                    </div>
                    <div
                      className={cn(
                        'text-xxs',
                        data?.selected_variant?.uuid === item?.uuid
                          ? 'text-primary-500'
                          : 'text-gray-500'
                      )}
                    >
                      {item?.final_price_human}
                    </div>
                    <div className="!mt-auto">
                      {remaining <= 0 ? (
                        <div className="text-primary-500 font-medium text-xxs text-center leading-none">
                          Out of stock
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>

                {isExisting && (
                  <span className="tooltip rounded shadow-lg p-2 py-1.5 leading-tight bg-gray-900 bg-opacity-90 text-white text-xxs absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-28">
                    <div>This variant already exists inside the cart.</div>
                  </span>
                )}
              </div>
            );
          })
        ) : (
          <div className="text-center text-gray-400 text-xs col-span-3 py-5">
            <i>There are no variants for this product.</i>
          </div>
        )}
      </div>
    </div>
  );
}

Variants.defaultProps = {
  form: {},
  setForm: () => {},
  variantExists: -1,
  data: {},
};

Variants.propTypes = {
  form: PropTypes.instanceOf(Object),
  data: PropTypes.instanceOf(Object),
  setForm: PropTypes.instanceOf(Function),
  variantExists: PropTypes.number,
};

export default Variants;
